export default {
    namespaced      : true,
    
    state           : {
      isOpenModal             : false,
      characterApplicationId  : null,
    },
  
    mutations       : {
      setIsOpenModal(state, value){
        state.isOpenModal = value;
      },

      setCharacterApplicationId(state, value){
        state.characterApplicationId = value;
      },

      resetStore(state){
        state.isOpenModal             = false;
        state.characterApplicationId  = null;
      }
    },
  
    actions         : {
      updateModal(context, payload){
        if(typeof payload.isOpen !== 'undefined'){
          context.commit('setIsOpenModal', payload.isOpen);
        }

        if(typeof payload.characterApplicationId !== 'undefined'){
          context.commit('setCharacterApplicationId', payload.characterApplicationId);
        }
      },

      resetStore(context){
        context.commit('resetStore');
      }
    }
  }
  